import { GeneralStyle } from '@website-builder/model/style/general-style';

export class SocialStyle extends GeneralStyle {
  name = '';
  color = '';
  decoration = '';
  size = 'tb-icon-medium';
  itemsGap = 'uk-margin-small-right';
  decorationColor = '';
  hoverColor = '';

  static normalize(styles: Partial<SocialStyle>): SocialStyle {
    const pureStyles = new SocialStyle();

    pureStyles.name = styles.name ?? pureStyles.name;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.itemsGap = styles.itemsGap ?? pureStyles.itemsGap;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.hoverColor = styles.hoverColor ?? pureStyles.hoverColor;

    return pureStyles;
  }
}
